import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

import { SlackChannelSettingsFragment, SlackChannelSettings } from './common';

export interface UpdateSlackSettingsInputType extends SlackChannelSettings {
  eventId: number;
}

export interface UpdateSlackSettingsResult {
  updateSlackSettings: {
    ok: boolean;
    event: SlackChannelSettings;
  };
}

const UpdateSlackSettingsMutation = gql`
  mutation updateSlackSettings($input: UpdateSlackSettingsInputType!) {
    updateSlackSettings(input: $input) {
      ok
      event {
        ...SlackChannelSettingsFragment
      }
    }
  }
  ${SlackChannelSettingsFragment}
`;

export const updateSlackSettings = (
  input: UpdateSlackSettingsInputType
): Promise<UpdateSlackSettingsResult> => {
  return gqlClient.request<UpdateSlackSettingsResult>(UpdateSlackSettingsMutation, {
    input
  });
};
